'use client';
import { v4 as uuidv4 } from 'uuid';
import { PaginationButton } from '@/components/atoms';
import { CollapseIcon, MeatballsMenuIcon } from '@/icons';

export const Pagination = ({
  pages,
  setPage,
  currentPage,
}: {
  pages: number;
  setPage: (page: number) => void;
  currentPage: number;
}) => {
  if(pages === 0) {
    return <></>
  }
  const renderPaginationButtons = () => {
    const buttons = [];
    const showPageHalfCount = 3;
    let startPage = currentPage - showPageHalfCount;
    let endPage = currentPage + showPageHalfCount;
    if (startPage < 1) {
      endPage += Math.abs(startPage - 1)
      startPage = 1;
    }
    if (endPage > pages) {
      startPage -= endPage - pages
      endPage = pages;
      if (startPage < 1) {
        startPage = 1;
      }
    }

    for (let index = startPage; index <= endPage; index++) {
      let current = index;
      buttons.push(
        <PaginationButton
          isActive={current === currentPage}
          key={uuidv4()}
          onClick={() => setPage(current)}
        >
          {current}
        </PaginationButton>
      );
    }
    return buttons;
  };

  return (
    <div className='flex items-center gap-[8px]'>
      <PaginationButton
        disabled={Boolean(currentPage === 1)}
        onClick={() => setPage(currentPage - 1)}
      >
        <CollapseIcon size={20} className='rotate-90' />
      </PaginationButton>

      {renderPaginationButtons()}

      <PaginationButton
        disabled={Boolean(currentPage === pages || pages === 0)}
        onClick={() => setPage(currentPage + 1)}
      >
        <CollapseIcon size={20} className='-rotate-90' />
      </PaginationButton>
    </div>
  );
};
